import { useLocale } from '@solinkcorp/locale';

export function useDayPartsLocale() {
  const locale = useLocale();

  return [
    locale.serviceDisplayMonitor.dayPart.sunday,
    locale.serviceDisplayMonitor.dayPart.monday,
    locale.serviceDisplayMonitor.dayPart.tuesday,
    locale.serviceDisplayMonitor.dayPart.wednesday,
    locale.serviceDisplayMonitor.dayPart.thursday,
    locale.serviceDisplayMonitor.dayPart.friday,
    locale.serviceDisplayMonitor.dayPart.saturday,
    locale.serviceDisplayMonitor.dayPart.week,
  ] as const;
}
